// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#077c82","colorSecondary":"#ad9442","green":"#2da44e","red":"#e6746a","orange":"#d6af38"};